import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/app/node_modules/css-loader/dist/runtime/api.js'
import '/app/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('map-interactive', wrap(Vue, () => import('~root/./src/components/Interactive.vue?shadow')))

window.customElements.define('map-simple', wrap(Vue, () => import('~root/./src/components/Simple.vue?shadow')))